import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-session-timeout',
  templateUrl: './session-timeout.component.html',
  styleUrls: ['./session-timeout.component.scss'],
  imports: [MatButtonModule]
})
export class SessionTimeoutComponent implements OnInit, OnDestroy {

  totalSeconds = 0;

  minutes = 0;
  seconds = 0;

  private intervalId: any;

  constructor(
    private dialogRef: MatDialogRef<SessionTimeoutComponent>
  ) { }

  ngOnInit(): void {
    const tokenExpiryStr = localStorage.getItem('auth0_token_expiry_time');
    if (tokenExpiryStr) {
      const tokenExpiry = parseInt(tokenExpiryStr, 10);
      const remainingMs = tokenExpiry - new Date().getTime();
      this.totalSeconds = remainingMs > 0 ? Math.floor(remainingMs / 1000) : 0;
    } else {
      this.totalSeconds = 120; // Default fallback
    }

    if (this.totalSeconds > 0) {
      this.minutes = Math.floor(this.totalSeconds / 60);
      this.seconds = this.totalSeconds % 60;
      this.startCountdown();
    } else {
      this.logoutNow();
    }
  }

  startCountdown(): void {

    this.intervalId = setInterval(() => {

      this.totalSeconds--;

      this.minutes = Math.floor(this.totalSeconds / 60);
      this.seconds = this.totalSeconds % 60;

      if (this.totalSeconds <= 0) {
        this.logoutNow();
      }

    }, 1000);
  }

  stayLoggedIn(): void {
    this.dialogRef.close('continue');
  }

  logoutNow(): void {
    this.dialogRef.close('logout');
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }
}